import { PostgrestClient } from "@supabase/postgrest-js";
import { getPostgrestUrl } from "./index";

/**
 * Creates an unauthenticated PostgreSQL client for public endpoints
 * Used for auth operations (login, password reset, etc.) that don't require authentication
 */
export const createUnauthenticatedPostgrest = (): PostgrestClient => {
  return new PostgrestClient(getPostgrestUrl());
};
